<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-review@3x.svg" alt="" />
    <span>Review</span>
  </ng-container>

  <div body>
    <div *ngIf="isRedirecting">
      <app-loading>
        <ng-container body>
          <div class="redirect-text">You are being redirected to DocuSign</div>
        </ng-container>
      </app-loading>
    </div>

    <div *ngIf="model.organization && model.contactPerson" class="box">
      <div class="section-wrapper">
        <div class="section-title">Organisation's information</div>
        <div class="row">
          <div class="col-lg-4 data-group">
            <app-data-point>
              <span label>Name of organisation</span>
              <div value>{{ model.organization.companyName }}</div>
            </app-data-point>
          </div>
          <div class="col-lg-8 data-group">
            <app-data-point>
              <span label>Main address</span>
              <div value>{{ model.organization.mainAddress }}</div>
            </app-data-point>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 data-group">
            <app-data-point>
              <span label>Telephone number</span>
              <div value>{{ model.organization.telephoneNo }}</div>
            </app-data-point>
          </div>
          <div class="col-lg-4 data-group">
            <app-data-point>
              <span label>Fax number</span>
              <div value>{{ model.organization.faxNo }}</div>
            </app-data-point>
          </div>
        </div>
      </div>
      <div class="section-wrapper">
        <div class="section-title">Contact person information</div>
        <div class="row">
          <div class="col data-group">
            <app-data-point>
              <span label>Name of organisation's representative</span>
              <div value>
                {{ model.contactPerson.organizationRepresentative }}
              </div>
            </app-data-point>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 data-group">
            <app-data-point>
              <span label>Email address</span>
              <div value>
                {{ model.contactPerson.emailAddress }}
              </div>
            </app-data-point>
          </div>
          <div class="col-lg-4 data-group">
            <app-data-point>
              <span label>Mobile number</span>
              <div value>
                {{ model.contactPerson.mobileNo }}
              </div>
            </app-data-point>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="model.treasuryAdvisorName && model.lastFNADate" class="box">
      <div class="row">
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Name of Treasury Advisor</span>
            <div value>
              {{ model.treasuryAdvisorName }}
            </div>
          </app-data-point>
        </div>
        <div class="col-lg-4 data-group">
          <app-data-point>
            <span label>Date of last FNA done</span>
            <div value>
              {{ model.lastFNADate }}
            </div>
          </app-data-point>
        </div>
      </div>
    </div>

    <section class="box">
      <div class="section-title">
        Risk profile
        <span class="blue-link edit-text" (click)="goToRiskAssessmentScreen()">
          <div class="edit-icon"></div>
          Edit
        </span>
      </div>
      <div class="row">
        <div class="col-lg-4 data-group">
          <app-data-point *ngIf="model.assessedRiskProfile">
            <span label>Your assessed profile</span>
            <div value>{{ model.assessedRiskProfile }}</div>
          </app-data-point>
        </div>
        <div class="col-lg-4 data-group">
          <app-data-point *ngIf="model.declaredRiskProfile">
            <span label>Your declared profile</span>
            <div value>{{ model.declaredRiskProfile }}</div>
          </app-data-point>
        </div>
      </div>
      <div *ngIf="declaredNotEqualAssessed" style="margin-top: 30px">
        <app-alert>
          <div>
            The result of our assessment is different from your Organisation’s
            view of its risk profile. <br />
            This will affect the products we will be recommending to you
          </div>
        </app-alert>
        <div style="margin-top: 30px">
          <app-data-point>
            <span label
              >Do you wish to accept the risk profile assessment?</span
            >
            <div value>
              {{ model.isAcceptAssessedRiskProfile ? 'Yes' : 'No' }}
            </div>
          </app-data-point>
        </div>
      </div>
    </section>

    <section class="box">
      <div class="section-title">
        Product list
        <span class="blue-link edit-text" (click)="goToProductScreen()">
          <div class="edit-icon"></div>
          Edit
        </span>
      </div>

      <ng-container *ngIf="model.isAcceptAssessedRiskProfile">
        <div class="row">
          <div class="col data-group">
            <app-data-point>
              <span label
                >Do you accept the recommended products in Table A?</span
              >
              <div value>
                {{ model.isAcceptRecommendedProducts ? 'Yes' : 'No' }}
              </div>
            </app-data-point>
          </div>
        </div>
        <div class="row" *ngIf="model.isAcceptRecommendedProducts">
          <div class="col data-group">
            <app-data-point>
              <span label
                >Do you also wish to purchase other products in Table B?</span
              >
              <div value>
                {{ model.isPurchaseTableBProducts ? 'Yes' : 'No' }}
              </div>
            </app-data-point>
          </div>
        </div>
      </ng-container>

      <div class="box-white box-product-list" *ngIf="recommendedLowRiskOption.length > 0 || recommendedModerateRiskOption.length > 0 || recommendedHighRiskOption.length > 0">
        <div class="product-list-header">Table A: Recommended products</div>
        <div class="product-list-description-wrapper">
          <div class="risk-section" *ngIf="recommendedLowRiskOption.length > 0">
            <div class="risk-title">Low risk</div>
            <div
              class="risk-description"
              *ngFor="let product of recommendedLowRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="recommendedModerateRiskOption.length > 0"
          >
            <div class="risk-title">Moderate risk</div>
            <div
              class="risk-description"
              *ngFor="let product of recommendedModerateRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="recommendedHighRiskOption.length > 0"
          >
            <div class="risk-title">High risk</div>
            <div
              class="risk-description"
              *ngFor="let product of recommendedHighRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-white box-product-list" *ngIf="selectedNonRecommendedLowRiskOption.length > 0 || selectedNonRecommendedModerateRiskOption.length > 0 || selectedNonRecommendedHighRiskOption.length > 0">
        <div class="product-list-header" *ngIf="selectedNonRecommendedLowRiskOption.length > 0 || selectedNonRecommendedModerateRiskOption.length > 0 || selectedNonRecommendedHighRiskOption.length > 0">Table B: Non-recommended products</div>
        <div class="product-list-description-wrapper">
          <div
            class="risk-section"
            *ngIf="selectedNonRecommendedLowRiskOption.length > 0"
          >
            <div class="risk-title">Low risk</div>
            <div
              class="risk-description"
              *ngFor="let product of selectedNonRecommendedLowRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="selectedNonRecommendedModerateRiskOption.length > 0"
          >
            <div class="risk-title">Moderate risk</div>
            <div
              class="risk-description"
              *ngFor="let product of selectedNonRecommendedModerateRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="selectedNonRecommendedHighRiskOption.length > 0"
          >
            <div class="risk-title">High risk</div>
            <div
              class="risk-description"
              *ngFor="let product of selectedNonRecommendedHighRiskOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="selectedNonRecommendedOthersOption.length > 0"
          >
            <div class="risk-title">Others</div>
            <div
              class="risk-description"
              *ngFor="let product of selectedNonRecommendedOthersOption"
            >
              <div class="product-title">{{ product.title }}</div>
              <div
                *ngIf="product.shortDescription"
                class="managed-content product-description"
                [innerHTML]="product.shortDescription"
              ></div>
              <div class="product-addition-content">
                {{ model.treasuryAdvisorName }} will contact you upon the
                submission of the Financial Needs Analysis
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <form [formGroup]="form" (ngSubmit)="model.onSubmitDocusign()">
      <section class="declaration-section">
        <div class="section-title">Declaration</div>
        <div class="declaration-message">
          By signing below,

          <app-checkbox
            label="I confirm that the information I have provided on behalf of the organisation is correct to the best of my knowledge and belief. I have provided this information on the understanding that it will be used to form the basis of any investment advice and/or recommendation(s) made to the organisation and that the organisation is not under any obligation to take up any recommendation(s) made. I also recognise that failing to providing all relevant information or providing incorrect, inaccurate, false or misleading information would reduce and the quality of investment advice and/or recommendation(s) given to the organisation."
            [border]="false"
            class="declaration-checkbox"
            [value]="isAcknowledgeDeclarationControl.value"
            formControlName="isAcknowledgeDeclaration"
          ></app-checkbox>
          <div
            *ngIf="
              isAcknowledgeDeclarationControl.touched &&
              isAcknowledgeDeclarationControl.errors?.required
            "
            class="error"
          >
            Please acknowledge this statement
          </div>

          <app-checkbox
            [label]="productDeclarationStatement"
            [border]="false"
            class="declaration-checkbox"
            [value]="isAcknowledgeProductRiskControl.value"
            formControlName="isAcknowledgeProductRisk"
          ></app-checkbox>
          <div
            *ngIf="
              isAcknowledgeProductRiskControl.touched &&
              isAcknowledgeProductRiskControl.errors?.required
            "
            class="error"
          >
            Please acknowledge this statement
          </div>

          <app-checkbox
            label='I acknowledge that I have read and understood the <a href="./assets/pdf/Appendix%20A%20-%20Risk%20Disclosure%20Statement.pdf"
          target="_blank" class="blue-link">Risk Disclosure Statement</a> in Appendix A.'
            [border]="false"
            class="declaration-checkbox"
            [value]="isAcknowledgeRiskDisclosureControl.value"
            formControlName="isAcknowledgeRiskDisclosure"
          ></app-checkbox>
          <div
            *ngIf="
              isAcknowledgeRiskDisclosureControl.touched &&
              isAcknowledgeRiskDisclosureControl.errors?.required
            "
            class="error"
          >
            Please read the Risk Disclosure Statement
          </div>

          <div
            class="declaration-checkbox"
            *ngIf="
              model.contactPerson?.organizationRepresentative &&
              model.organization
            "
          >
            This declaration must be signed by
            <b>{{ model.contactPerson?.organizationRepresentative }}</b> on
            behalf of <b>{{ model.organization.companyName }}</b
            >.
          </div>
        </div>

        <div class="declaration-note" *ngIf="model.declarationNote">
          <span [innerHTML]="model.declarationNote"></span>
        </div>
      </section>

      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-red-button buttonType="submit">Sign document</app-red-button>
        <!-- <app-red-button (click)="handleLogout()">test</app-red-button> -->

        
      </div>
    </form>
    <div *ngIf="globals.isDebug" class="mt56">
      <h3>Information for developers, please ignore</h3>
      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
    </div>
  </div>
  <ng-template #modalDocusign let-modal>
    <div class="modal-header scroll-shadow-top">
      <div class="modal-title">{{ model.docusignWarningMessage }}</div>
    </div>
    <!-- <div
      class="modal-body modal-content-padding"
      [innerHTML]="model.termsAndConditions?.body"
    ></div> -->
    <div class="modal-footer scroll-shadow-bottom modal-footer-button">
      <app-primary-button
        [outline]="true"
        (click)="handleRejectDocusignRedirect()"
        >Reject</app-primary-button
      >
      <app-primary-button (click)="handleAcceptDocusignRedirect()"
        >Accept</app-primary-button
      >
     
    </div>
  </ng-template>
</app-screen-content>
